import { useEffect } from 'react';

export const useCustomFavicon = (): void => {
	const setFavicon = (iconURL: string): void => {
		const link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
		link.type = 'image/x-icon';
		link.rel = 'shortcut icon';
		link.href = iconURL;
		// @ts-expect-error ignore index signature error
		document.getElementsByTagName('head')[0].appendChild(link);
	};

	useEffect(() => {
		const faviconMapping: { [key: string]: string } = {
			eyeqmarketplace: '/favicon-eyeq.png',
			apollo: '/favicon-atom.png',
			atom: '/favicon-atom.png',
			ipl: '/favicon-ipl.png',
			// Add more mappings as needed
		};

		const hostParts = window.location.host.split('.');
		const companyName =
			Object.keys(faviconMapping).find((key) => hostParts.some((part) => part.includes(key))) || '';
		const faviconURL = faviconMapping[companyName] || '/favicon.ico';

		setFavicon(process.env.PUBLIC_URL + faviconURL);
	}, []);
};
export {};
